import React from 'react';
import {IBrand} from '../../types/Filter';
import PillRow from './Pill';

interface BrandPillsProps {
  brands: IBrand[];
  selectedBrands: string[];
  onSelect: (brandNames: string[]) => void;
}

const BrandPills = ({brands, selectedBrands, onSelect}: BrandPillsProps) => (
  <PillRow
    items={(brands ?? []).map(brand => ({
      key: brand.name,
      label: brand.name,
      imageUrl: brand.url,
    }))}
    selectedKeys={selectedBrands}
    onSelectMulti={onSelect}
    withImage
  />
);

export default BrandPills;
